var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[(_vm.vehicles && _vm.vehicles.length > 0)?_vm._l((_vm.vehicles),function(vehicle){return _c('v-col',{key:vehicle.id,attrs:{"cols":"12","md":"6","xl":"4"}},[_c('DisplayCard',{attrs:{"vehicle":vehicle,"customer":_vm.customer}})],1)}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }